// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import GifOutlinedSvg from "@ant-design/icons-svg/es/asn/GifOutlined";
import AntdIcon from '../components/AntdIcon';

var GifOutlined = function GifOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: GifOutlinedSvg
  }));
};

GifOutlined.displayName = 'GifOutlined';
export default React.forwardRef(GifOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/GifOutlined.js
// module id = 1253
// module chunks = 0